// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"46aae4f6","885":"3a485a3b"}[chunkId] + ".chunk.js";
};